export const CLASSIFICATION_STATUS_CODES = {
  ADM: 'ADM',
  PM: 'PM',
  DEV: 'DEV',
  ADFT: 'ADFT',
  AAUTH: 'AAUTH',
  ASUB: 'ASUB',
  SHF: 'SHF',
  AACP: 'AACP',
  AAPR: 'AAPR',
  EMLAS: 'EMLAS'
};

export const CLASSIFICATIONS_DOMAIN_CODES = {
  OF: {
    NAME: 'Offer Files',
    CODE: 'OF'
  }
}

export const CREDIT_RETIREMENT_STATUS = {
  H: {
    NAME: 'Held',
    CODE: 'H'
  },
  PR: {
    NAME: 'Pending Retirement',
    CODE: 'PR'
  },
  R: {
    NAME: 'Retired',
    CODE: 'R'
  },
  VTR: {
    NAME: 'Verify Transfer ',
    CODE: 'VT'
  },
  ART: {
    NAME: 'Approve Retirement ',
    CODE: 'AR'
  },
  VRT: {
    NAME: 'Verify Retirement ',
    CODE: 'VR'
  }
}

export const QuoteFileTypes = {
  'NSWDevelopmentApplication': 'QFNSWDEV',
  'NSWDevelopmentApproved': 'QFNSWAPR',
  'CommonwealthApproved': 'QFCWAPR',
  'CreditReport': 'QFCR',
  'EquivalenceStatement': 'QFEQS'
}

//Quote application statuses
export const QuoteApplicationStatus = {
  'Issued': 'ISS',
  'Accepted': 'ACP',
  'PartiallyAccepted': 'PARACP',
  'InProgress': 'PROG',
  'Cancelled': 'CAN',
  'Draft':'DFT'
}

export const RTMPApplicationStatus = {
  'InProgress': 'PROG',
  'Cancelled': 'CAN',
  'Draft':'DFT',
  'Completed': 'COMPL',
}

export const OFFSET_STATUTORY_OBLIGATION_TYPE = {
  'Part3': 'Part 3 Planning Proposal',
  'PART4': 'Part 4 - Local Development',
  'PART5': 'Part 5 - Activities',
  'Part3A': 'Part 3A',
  'Part5A': 'Part 5A LLS Act',
  'VEGNR': 'Vegetation in Non-Rural Areas SEPP',
  'LEC': 'LEC Consent Order',
  'VPA': 'Voluntary Planning Agreement',
  'SSD': 'State Significant Development (SSD)',
  'SSI': 'State Significant Infrastructure(SSI)'
}

export const getObligationTypeDescription = (key: string): string => {
  const description = OFFSET_STATUTORY_OBLIGATION_TYPE[key as keyof typeof OFFSET_STATUTORY_OBLIGATION_TYPE];
  return description ? description : "";
};

export const getStatusName = (status: {}, givenKey: string) => {
  for (const key in status) {
    if (givenKey === status[key]) {
      return key;
    }

    if (givenKey === key) {
      return status[givenKey];
    }
  }
}
